import { Routes } from '@angular/router';
import { HomeComponent } from './modules/home/home.component';
import { CupomWizardComponent } from './modules/cupons/cupom-wizard/cupom-wizard.component';
import { CupomListComponent } from './modules/cupons/cupom-list/cupom-list.component';
import { CupomConferenciaComponent } from './modules/cupons/cupom-conferencia/cupom-conferencia.component';
import { CupomEditComponent } from './modules/cupons/cupom-edit/cupom-edit.component';
import { GatilhoListComponent } from './modules/gatilhos/gatilho-list/gatilho-list.component';
import { GatilhoFormComponent } from './modules/gatilhos/gatilho-form/gatilho-form.component';
import { LoginComponent } from './modules/auth/login/login.component';
import { AppShellComponent } from './shared/layout/app-shell.component';
import { UsuariosComponent } from './modules/usuarios/usuarios.component';
import { RelatoriosComponent } from './modules/relatorios/relatorios.component';
import { authGuard } from './core/auth/auth.guard';
import { roleGuard } from './core/auth/role.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: AppShellComponent,
    canActivate: [authGuard],
    children: [
      { path: 'inicio',              component: HomeComponent,            canActivate: [roleGuard], data: { role: 'ADMIN' } },
      { path: 'cupons',              component: CupomListComponent,       canActivate: [roleGuard], data: { role: 'ADMIN' } },
      { path: 'cupons/novo',         component: CupomWizardComponent,     canActivate: [roleGuard], data: { role: 'ADMIN' } },
      { path: 'cupons/:id/editar',   component: CupomEditComponent,       canActivate: [roleGuard], data: { role: 'ADMIN' } },
      { path: 'conferencia',         component: CupomConferenciaComponent },
      { path: 'gatilhos',            component: GatilhoListComponent,     canActivate: [roleGuard], data: { role: 'ADMIN' } },
      { path: 'gatilhos/novo',       component: GatilhoFormComponent,     canActivate: [roleGuard], data: { role: 'ADMIN' } },
      { path: 'gatilhos/:id/editar', component: GatilhoFormComponent,     canActivate: [roleGuard], data: { role: 'ADMIN' } },
      { path: 'usuarios',            component: UsuariosComponent,        canActivate: [roleGuard], data: { role: 'ADMIN' } },
      { path: 'relatorios',          component: RelatoriosComponent,      canActivate: [roleGuard], data: { role: 'ADMIN' } },
      { path: '', redirectTo: 'inicio', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'inicio' },
];
